import * as Yup from "yup";
import dayjs from "dayjs";
import { msg } from "../../vehicleFormErrors";

/*
 * Messages are i18n KEYS (see vehicleFormErrors.ts), translated where they
 * are displayed. Before the STC incident nothing displayed them at all.
 */
export const validationSchemaCreateVehicle = Yup.object().shape({
  vin: Yup.string().trim().required(msg("required")),
  immatriculation: Yup.string().trim().required(msg("required")),
  // brand / modele hold the id of an option picked IN THE LIST. A name that
  // was typed but matches no option never reaches here (the field is
  // strict), so "missing" really means "not chosen from the list".
  brand: Yup.string().required(msg("brandFromList")),
  modele: Yup.string().required(msg("modelFromList")),
  gearBox: Yup.string().required(msg("required")),
  fiscalPower: Yup.string().trim().required(msg("required")),
  energy: Yup.string().required(msg("required")),
  releaseDate: Yup.string()
    .required(msg("required"))
    .test("valid-date", msg("dateInvalid"), (value) =>
      !value ? true : dayjs(value, "YYYY-MM-DD").isValid()
    ),
  status: Yup.string().required(msg("required")),
  isLeasing: Yup.string().required(msg("leasingRequired")),
});

export interface FormValuesVehicle {
  vin: string;
  immatriculation: string;
  brand: string;
  modele: string;
  gearBox: string;
  fiscalPower: string;
  energy: string;
  releaseDate: string;
  status: string;
  isLeasing: string;
}

export const initialValuesVehicle: FormValuesVehicle = {
  vin: "",
  immatriculation: "",
  brand: "",
  modele: "",
  gearBox: "",
  fiscalPower: "",
  energy: "",
  releaseDate: "",
  status: "",
  isLeasing: "",
};
